'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressFieldLimiter = function () {
  function AddressFieldLimiter() {
    (0, _classCallCheck3.default)(this, AddressFieldLimiter);

    // Store the elements to be limited
    this.els = {
      acountAddress1: (0, _functional.getElements)('[id^="AddressAddress1"]'),
      acountAddress2: (0, _functional.getElements)('[id^="AddressAddress2"]'),
      acountAddressCity: (0, _functional.getElements)('[id^="AddressCity"]')
    };
    this.elsNames = {
      acountAddressNewFirstName: (0, _functional.getElements)('[id^="AddressFirstNameNew"]'),
      acountAddressFirstName: (0, _functional.getElements)('[name="address[first_name]"]'),
      acountAddressNewLastName: (0, _functional.getElements)('[id^="AddressLastNameNew"]'),
      acountAddressLastName: (0, _functional.getElements)('[name="address[last_name]"]')
    };
    this.maxLength = 30;
    this.maxLengthName = 20;

    this.init();
  }

  (0, _createClass3.default)(AddressFieldLimiter, [{
    key: 'init',
    value: function init() {
      this.applyMaxLength(this.els, this.maxLength);
      this.applyMaxLength(this.elsNames, this.maxLengthName);
    }

    // Truncate the initial value of the field if it exceeds maxLength

  }, {
    key: 'truncateInitialValue',
    value: function truncateInitialValue(field, maxLength) {
      if (field.value.length > maxLength) {
        field.value = field.value.substring(0, maxLength);
      }
    }

    // Limit the typing in the field to maxLength

  }, {
    key: 'limitTyping',
    value: function limitTyping(e, maxLength) {
      var target = e.target;
      if (target.value.length > maxLength) {
        target.value = target.value.substring(0, maxLength);
      }
    }

    // Set up event listeners for the field

  }, {
    key: 'setupListeners',
    value: function setupListeners(field, maxLength) {
      var _this = this;

      field.addEventListener('keyup', function (e) {
        return _this.limitTyping(e, maxLength);
      });
      field.addEventListener('focusout', function (e) {
        return _this.limitTyping(e, maxLength);
      });
    }

    // Apply maxLength to each field, truncate initial value and set up event listeners

  }, {
    key: 'applyMaxLength',
    value: function applyMaxLength(els, maxLength) {
      var _this2 = this;

      Object.values(els).forEach(function (fields) {
        fields.forEach(function (field) {
          if (!field) return;

          field.maxLength = maxLength;
          _this2.truncateInitialValue(field, maxLength);
          _this2.setupListeners(field, maxLength);
        });
      });
    }
  }]);
  return AddressFieldLimiter;
}();

exports.default = AddressFieldLimiter;


new AddressFieldLimiter();